import { Product, ProductSchema } from '../../api/dbs/models';
import z from 'zod';
import { AppLocale } from 'utils/parseAnyLocale';
import { LocaleKey } from '@raisin/cp-utils';

export const CsProductCardsProductLabelSchema = z.enum([
  'TopOffer',
  'Flexgeld',
  'StructuredDeposit',
  'SpecialOffer',
  'ShariaAccount',
  'RateReducingSoon',
  'RaisinUkExclusive',
  'OnlineAbschluss',
  'MarketLeadingRate',
  'FesterAnlagebetrag',
  'KeineQuellensteuer',
  'FinanztestBestenliste',
  'SustainableDeposit',
  'AutomaticTaxHandling',
]);
export type CsProductCardsProductLabel = z.infer<typeof CsProductCardsProductLabelSchema>;

export const CsProductCardsProductSchema = z.object({
  product_id: z.string(),
  label: z.array(CsProductCardsProductLabelSchema).max(2),
  use_custom_label: z.boolean().optional(),
  custom_label_text: z.string().optional(),
});

export type CsProductCardsProduct = z.infer<typeof CsProductCardsProductSchema>;

export const CsProductCardsSectionSchema = z
  .object({
    section_id: z.string(),
    title: z.string().nullish(),
    products: z.array(CsProductCardsProductSchema),
  })
  .transform((value) => ({
    ...value,
    productIds: value.products.map(({ product_id }) => product_id),
  }));

export type CsProductCardsSection = z.infer<typeof CsProductCardsSectionSchema>;

export const CsProductCardsSchema = z
  .object({
    uid: z.string(),
    header: z.string().nullish(),
    description: z.string().nullish(),
    sections: z.array(CsProductCardsSectionSchema),
  })
  .transform((value) => ({
    ...value,
    productIds: value.sections.flatMap((section) => section.productIds),
  }));

export type CsProductCards = z.infer<typeof CsProductCardsSchema>;

export const ProductDictionarySchema = z.record(z.string(), ProductSchema);
export type ProductDictionary = z.infer<typeof ProductDictionarySchema>;

export type ProductCardsProps = {
  locale: AppLocale | LocaleKey;
  dbs: Record<Product['id'], Product>;
  errors?: string[];
} & CsProductCards;
